angular.module('elfium').service('elfiumRestService', ['$q', '$http', '$filter', 'elfiumUrlService', 'elfiumSpinnerService',
    function ($q, $http, $filter, elfiumUrlService, elfiumSpinnerService) {
        var that = this;
        that._authorizationToken = null;
        that.setToken = function (token) {
            that._authorizationToken = token;
        };
        that.resetToken = function () {
            that._authorizationToken = null;
        };
        that.getContacts = function ()  {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/contacts';
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.getContact = function (contactId)  {
            if (!contactId) {
                throw "contactId empty in elfiumRestService/getContact";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/contact/' + contactId;
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.createContact = function (contact) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/contacts';
            return that._sendAuthorizedHttpRequest('POST', url, contact);
        };
        that.updateContact = function (contact) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/contact/' + contact.id;
            return that._sendAuthorizedHttpRequest('PUT', url, contact);
        };
        that.searchContacts = function (searchParameters) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/searchContacts';
            return that._sendAuthorizedHttpRequest('POST', url, searchParameters);  
        };
        that.deleteContact = function (contactId) {
            if (!contactId) {
                throw "contactId empty in elfiumRestService/deleteContact";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/contact/' + contactId;
            return that._sendAuthorizedHttpRequest('DELETE', url);
        };
        that.getCompanies = function () {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/companies';
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.getCompany = function (companyId) {
            if (!companyId) {
                throw "companyId empty in elfiumRestService/getCompany";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/company/' + companyId;
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.createCompany = function (company) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/companies';
            return that._sendAuthorizedHttpRequest('POST', url, company);
        };
        that.updateCompany = function (company) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/company/' + company.id;
            return that._sendAuthorizedHttpRequest('PUT', url, company);
        };
        that.searchCompanies = function (searchParameters) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/searchCompanies';
            return that._sendAuthorizedHttpRequest('POST', url, searchParameters);  
        };
        that.deleteCompany = function (companyId) {
            if (!companyId) {
                throw "companyId empty in elfiumRestService/deleteCompany";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/company/' + companyId;
            return that._sendAuthorizedHttpRequest('DELETE', url);
        };
        that.getTasks = function () {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/tasks';
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.getTask = function (taskId) {
            if (!taskId) {
                throw "taskId empty in elfiumRestService/getTask";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/task/' + taskId;
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.createTask = function (task) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/tasks';
            return that._sendAuthorizedHttpRequest('POST', url, task);
        };
        that.updateTask = function (task) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/task/' + task.id;
            return that._sendAuthorizedHttpRequest('PUT', url, task);
        };
        that.searchTasks = function (searchParameters) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/searchTasks';
            return that._sendAuthorizedHttpRequest('POST', url, searchParameters);  
        };
        that.deleteTask = function (taskId) {
            if (!taskId) {
                throw "taskId empty in elfiumRestService/deleteTask";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/task/' + taskId;
            return that._sendAuthorizedHttpRequest('DELETE', url);
        };
        that.getBusinessCases = function () {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/businessCases';
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.getBusinessCase = function (businessCaseId) {
            if (!businessCaseId) {
                throw "businessCaseId empty in elfiumRestService/getBusinessCase";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/businessCase/' + businessCaseId;
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.createBusinessCase = function (businessCase) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/businessCases';
            return that._sendAuthorizedHttpRequest('POST', url, businessCase);
        };
        that.updateBusinessCase = function (businessCase) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/businessCase/' + businessCase.id;
            return that._sendAuthorizedHttpRequest('PUT', url, businessCase);
        };
        that.searchBusinessCases = function (searchParameters) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/searchBusinessCases';
            return that._sendAuthorizedHttpRequest('POST', url, searchParameters);  
        };
        that.deleteBusinessCase = function (businessCaseId) {
            if (!businessCaseId) {
                throw "businessCaseId empty in elfiumRestService/deleteBusinessCase";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/businessCase/' + businessCaseId;
            return that._sendAuthorizedHttpRequest('DELETE', url);
        };
        that.createReport = function (report) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/reports';
            return that._sendAuthorizedHttpRequest('POST', url, report);
        };
        that.updateReport = function (report) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/report/' + report.id;
            return that._sendAuthorizedHttpRequest('PUT', url, report);
        };
        that.searchReports = function (searchParameters) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/searchReports';
            return that._sendAuthorizedHttpRequest('POST', url, searchParameters);  
        };
        that.deleteReport = function (reportId) {
            if (!reportId) {
                throw "reportId empty in elfiumRestService/deleteReport";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/report/' + reportId;
            return that._sendAuthorizedHttpRequest('DELETE', url);
        };
        that.createReportYear = function (reportYear) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/reportYears';
            return that._sendAuthorizedHttpRequest('POST', url, reportYear);
        };
        that.searchReportYears = function (searchParameters) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/searchReportYears';
            return that._sendAuthorizedHttpRequest('POST', url, searchParameters);  
        };
        that.deleteReportYear = function (reportYearId) {
            if (!reportYearId) {
                throw "reportYearId empty in elfiumRestService/deleteReportYear";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/reportYear/' + reportYearId;
            return that._sendAuthorizedHttpRequest('DELETE', url);
        };
        that.getUsers = function () {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/users';
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.getUser = function (userId) {
            if (!userId) {
                throw "userId empty in elfiumRestService/getUser";
            }
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/user/' + userId;
            return that._sendAuthorizedHttpRequest('GET', url);
        };
        that.updateUser = function (user) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/user/' + user.id;
            return that._sendAuthorizedHttpRequest('PUT', url, user);
        };
        that.searchUsers = function (searchParameters) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/searchUsers';
            return that._sendAuthorizedHttpRequest('POST', url, searchParameters);  
        };
        that.sendLoginRequest = function (email, password) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/login';
            var loginData = {
                email: email,
                password: password
            };
            return that._sendHttpRequest('POST', url, loginData);
        };
        that.sendRegistrationRequest = function (type, name, nameShort, email, password) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/register';
            var registrationData = {
                type: type,
                name: name,
                nameShort: nameShort,
                email: email,
                password: password
            };
            return that._sendAuthorizedHttpRequest('POST', url, registrationData);
        };
        that.sendLogoutRequest = function (email, password) {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/logout';
            return that._sendHttpRequest('GET', url);
        };
        that.getSessionLogin = function () {
            var url = elfiumUrlService.getBaseUrl() + 'backend/api.php/sessionLogin';
            return that._sendHttpRequest('GET', url);
        };
        that._sendHttpRequest = function (method, url, data, configuration)  {
            var deferred = $q.defer();
            configuration = configuration || {};
            angular.extend(configuration, {
                method: method,
                url: url,
                data: data
            });
            elfiumSpinnerService.spin();
            $http(configuration).then(function (response) {
                deferred.resolve(that._getParsedRestResponse(response));
            }, deferred.reject).finally(function () {
                elfiumSpinnerService.stop();
            });
            return deferred.promise;
        };
        that._sendAuthorizedHttpRequest = function (method, url, data)  {
            var configuration = {
                headers: null
            };
            if (that._authorizationToken) {
                configuration.headers = {
                    'Authorization': 'Bearer ' + that._authorizationToken
                }
            }
            return that._sendHttpRequest(method, url, data, configuration);
        };
        that._getParsedRestResponse = function (response) {
            return (response && response.data) ? response.data : null;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumRestService.ts